import type { AdminFeeTax } from 'application-types';
import { CURRENCY_CONVERSION } from 'lane-shared/helpers/constants';
import { TAX_VALUE_CONVERSION } from 'lane-shared/domains/billingPayments/constants';
import {
  TaxAmountType,
  type AddProductToChargeDetails,
} from 'lane-shared/domains/billingPayments/types';

type ProductAdminFeeTaxSource = {
  adminFeeTax?: AdminFeeTax | null;
};

export function adminFeeTaxFromChannelStorageToLineFields(
  tax: AdminFeeTax
): { type: TaxAmountType; value: string } {
  const type = tax.taxAmountType;

  if (type === TaxAmountType.TaxAmountTypeFixed) {
    return {
      type,
      value: String(tax.rate / CURRENCY_CONVERSION),
    };
  }

  return {
    type:
      type === TaxAmountType.TaxAmountTypePercentage
        ? type
        : TaxAmountType.TaxAmountTypePercentage,
    value: String(tax.rate / TAX_VALUE_CONVERSION),
  };
}

export function hasCatalogProductOwnAdminFeeTax(
  selectedProduct: ProductAdminFeeTaxSource
): boolean {
  const rate = selectedProduct.adminFeeTax?.rate;

  return rate != null && !Number.isNaN(Number(rate)) && Number(rate) > 0;
}

export function hasPositiveAdminFeeTaxOnChargeLine(
  adminFeeTax: AddProductToChargeDetails['adminFeeTax'] | undefined
): boolean {
  if (!adminFeeTax?.value) {
    return false;
  }

  const n = Number(adminFeeTax.value);

  return !Number.isNaN(n) && n > 0;
}

export function adminFeeTaxFieldsForSelectedChargeProduct(
  isAdminFeeFeatureEnabled: boolean,
  selectedProduct: ProductAdminFeeTaxSource
): { type: TaxAmountType; value: string } {
  if (!isAdminFeeFeatureEnabled) {
    return {
      type:
        selectedProduct?.adminFeeTax?.taxAmountType ||
        TaxAmountType.TaxAmountTypePercentage,
      value: selectedProduct?.adminFeeTax?.rate?.toString() ?? '0',
    };
  }

  if (hasCatalogProductOwnAdminFeeTax(selectedProduct)) {
    const catalogTax = selectedProduct.adminFeeTax;

    return {
      type:
        catalogTax?.taxAmountType ?? TaxAmountType.TaxAmountTypePercentage,
      value: String(catalogTax?.rate),
    };
  }

  return {
    type: TaxAmountType.TaxAmountTypePercentage,
    value: '',
  };
}
